var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tc3d1kg0za)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.333 3.333a.667.667 0 1 0 0-1.334v1.334zm-4.667-.667V2v.666zM1.333 4H.666h.667zm0 9.334H.666h.667zM14 8.666a.667.667 0 0 0-1.334 0H14zm-1.667-7-.471-.471.471.471zm1-.414V.585v.667zm1 2.414-.471-.471.471.471zM8 10l.161.647a.667.667 0 0 0 .31-.175L8 9.999zm-2.667.667-.647-.162a.667.667 0 0 0 .809.809l-.162-.647zM6 8l-.472-.47a.667.667 0 0 0-.175.309L6 8zm1.333-6H2.666v1.334h4.667V1.999zM2.666 2a2 2 0 0 0-1.414.586l.943.943a.667.667 0 0 1 .471-.195V1.999zm-1.414.586A2 2 0 0 0 .666 4H2c0-.176.07-.346.195-.47l-.943-.944zM.666 4v9.334H2V3.999H.666zm0 9.334a2 2 0 0 0 .586 1.414l.943-.943A.667.667 0 0 1 2 13.333H.666zm.586 1.414a2 2 0 0 0 1.414.586v-1.334a.666.666 0 0 1-.471-.195l-.943.943zm1.414.586H12v-1.334H2.666v1.334zm9.334 0a2 2 0 0 0 1.414-.586l-.943-.943A.666.666 0 0 1 12 14v1.334zm1.414-.586A2 2 0 0 0 14 13.333h-1.334c0 .177-.07.346-.195.471l.943.943zM14 13.333V8.666h-1.334v4.667H14zM12.804 2.138c.14-.14.33-.22.529-.22V.586a2.08 2.08 0 0 0-1.471.61l.942.943zm.529-.22c.198 0 .388.08.529.22l.942-.943a2.08 2.08 0 0 0-1.471-.61V1.92zm.529.22c.14.14.219.33.219.528h1.333a2.08 2.08 0 0 0-.61-1.471l-.942.943zm.219.528a.748.748 0 0 1-.22.529l.943.943c.39-.39.61-.92.61-1.472H14.08zm-.22.529L7.529 9.528l.943.943 6.333-6.333-.942-.943zM7.839 9.353l-2.667.666.324 1.294 2.666-.667-.323-1.293zM5.98 10.828l.666-2.667-1.293-.323-.667 2.667 1.294.323zM6.47 8.47l6.333-6.333-.942-.943-6.334 6.333.943.943z",
    fill: "#545454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tc3d1kg0za"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.ffabd1aa99fa1aa77c1615a8556aebdc.svg";
export { ForwardRef as ReactComponent };